import React from 'react';

function AuthenticateComponent(props) {
  return (
    props.auth ? (props.user.isAuthenticated ? props.children : '') : (!props.user.isAuthenticated ? props.children : '')
  );
}

export default AuthenticateComponent;
